import { render } from "./Disabled.vue?vue&type=template&id=2b7948c7&scoped=true"
const script = {}

import "./Disabled.vue?vue&type=style&index=0&id=2b7948c7&lang=scss&scoped=true"

import exportComponent from "C:\\xampp3\\htdocs\\a\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b7948c7"]])

export default __exports__